import Vue from 'vue';

import { SettingsState } from '@/store';
import { localize } from '@/core/filters';

export async function getTableLayoutFromUserSettings(tableKey: string): Promise<any> {
    const settings = SettingsState.contextSettings;
    const settingId = settings.tableLayouts[tableKey];
    if (settingId && settingId > 0) {
        const tableLayout = await SettingsState.changeService!.fetchTableLayoutSetting(settingId, tableKey);
        return JSON.parse(tableLayout.value);
    }
    return undefined;
}

export function saveTableLayoutToUserSettings(tableKey: string, state: any) {
    if (state) {
        delete state.selectedRowKeys;
    }
    SettingsState.changeService!.changeTableLayoutSetting(tableKey, JSON.stringify(state));
}

export function removeItemsFromView(grid: any, items: any[]) {
    for (const item of items) {
        grid.getDataSource().store().remove(item.id);
    }
    setTimeout(() => { grid.refresh(); }, 100);
}

export function getModifiedItems<Type>(grid: any): Type[] {
    return grid.getSelectedRowsData() as Type[];
}

export function checkField<Type>(
    items: Type[],
    field: keyof Type,
    defaultValueIfNull?: string
): boolean {
    const hasDefaultValue =
        defaultValueIfNull !== undefined &&
        defaultValueIfNull !== null &&
        defaultValueIfNull.length > 0;
    for (const item of items) {
        const isEmpty = !(
            item[field] && (item[field] as any).toString().trim()
        );
        if (isEmpty) {
            if (!hasDefaultValue) {
                return false;
            } else {
                (item[field] as any) = defaultValueIfNull!;
            }
        }
    }
    return true;
}

export function getTableCaption(tableKey: string): string {
    tableKey = tableKey.replace(new RegExp('-', 'g'), '_').toUpperCase();

    return localize(`${tableKey}_CAPTION`);
}

export function upendCell(cell: any, component: Vue) {
    if (component instanceof Vue) {
        component.$mount();
        cell.append(component.$el);
    } else {
        cell.append(component);
    }
}

export function updateTableHeaderWrap() {
    const wrapEnabled: boolean = SettingsState.contextSettings.global.enableTableColumnHeaderWordWrap || false;
    const headerCells = document.querySelectorAll('.dx-datagrid-text-content:not(.dx-datagrid-drag-header)');

    headerCells.forEach(element => {
        if (element.textContent !== '') {
            element.setAttribute('style', wrapEnabled ? 'white-space: normal !important' : 'white-space: inherit !important');
        }
    });
}
